import React, { useEffect, useState } from 'react'
import ModifyForm from './components/ModifyForm'
import { useDispatch } from 'react-redux'
import {
  setMilesNBonusAccount,
  setModifiedPrices,
  setSelectedExtras,
  setSelectedVehicle,
  setShowMilesNBouns,
  setType,
  setIsPrepaid,
} from '../../../js/lib/redux/slices/booking'
import Sidebar from '../Booking/components/Sidebar'

const ModifyReservation = () => {
  const { dictionary, vehicle, values } = window.modifyData
  const { milesNBonusAccount } = window.headerData
  const [loading, setLoading] = useState(true)
  const { pendingPayment, initialRedeemedMiles } = values || {}

  const { estimatedTotal } =
    vehicle?.car?.prepaidPrice || vehicle?.car?.returnPrice

  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(setSelectedVehicle(vehicle))
    dispatch(setSelectedExtras([]))
    pendingPayment ? dispatch(setType('pending')) : dispatch(setType('modify'))
    // dispatch(setModifiedPrices({}))
    const modifiedPrices = {
      initialPaymentWithCard: estimatedTotal - (initialRedeemedMiles || 0),
      initialPaymentWithMiles: initialRedeemedMiles || 0,
    }
    dispatch(setModifiedPrices(modifiedPrices))
    dispatch(setShowMilesNBouns(false))
    dispatch(setIsPrepaid(vehicle?.car?.prepaidPrice ? true : false))
    setLoading(false)

    if (!!milesNBonusAccount && milesNBonusAccount?.fFN) {
      dispatch(setMilesNBonusAccount(milesNBonusAccount))
    }
  }, [])

  if (loading) return <></>

  return (
    <div className="page-container s-modify-reservation">
      <h1 className="h1 m-0">{dictionary.modifyHeading}</h1>
      <div className="row">
        <div className="col-lg-7">
          <ModifyForm />
        </div>
        <div className="col-lg-4 offset-lg-1 d-none d-lg-block">
          <Sidebar />
        </div>
      </div>
    </div>
  )
}

export default ModifyReservation
